import * as Phaser from "phaser-ce"
import { CCUtils } from "../../../common/CCUtils"

export enum SharedSecondHandAssets {
    TRANSPARENT_BOX = "SharedSecondHandAssetsTRANSPARENT_BOX",
    BOX_FRONT = "SharedSecondHandAssetsBOX_FRONT",
    BOX_FRONT_MASK = "SharedSecondHandAssetsBOX_FRONT_MASK",
    BOX_BACK = "SharedSecondHandAssetsBOX_BACK",
    BOX_SMOKE = "SharedSecondHandAssetsBOX_SMOKE",
}

export function loadSharedAssets(game: Phaser.Game) {
    game.load.image(SharedSecondHandAssets.TRANSPARENT_BOX, CCUtils.asset("second-hand/transparent-box.png"))
    game.load.image(SharedSecondHandAssets.BOX_FRONT, CCUtils.asset("second-hand/box-front.png"))
    game.load.image(SharedSecondHandAssets.BOX_FRONT_MASK, CCUtils.asset("second-hand/box-front-mask.png"))
    game.load.image(SharedSecondHandAssets.BOX_BACK, CCUtils.asset("second-hand/box-back.png"))
    game.load.image(SharedSecondHandAssets.BOX_SMOKE, CCUtils.asset("second-hand/box-smoke.png"))
}
